<script>

    export default {
        alias: 'normalMessage',
        defaultOptions () {
            return {
                text: '消息',
                tpl: 'success'
            };
        },
        messageCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            if (!this.okCallback) {
                this.hideDetail = true;
            }
            this.img = this.tipImg[this.tpl];
            this.option.durationDom = this.$el.querySelector('.duration');
            this.durtime();
        },
        data () {
            const tipTplInfo = {
                'success': {
                    content: '&#xe692;',
                    color: '#008af0'
                },
                'warn': {
                    content: '&#xe68e;',
                    color: '#fa4100'
                }
            };
            return {
                hideDetail: false,
                tipImg: tipTplInfo,
                text: '',
                tpl: 'success',
                img: tipTplInfo['success'],
                option: {
                    duration: 0,
                    time: 3000,
                    freq: 30,
                    durationDom: null,
                    durationClock: null
                },
                hideClass: null
            };
        },
        name: 'normal-notify',
        methods: {
            durtime () {
                if (this.option.duration >= this.option.time) {
                    this.hide();
                } else {
                    this.option.duration += this.option.freq;
                    this.option.durationClock = setTimeout(this.durtime, this.option.freq);
                }
            },
            hide () {
                this.hideClass = 'hide';
                setTimeout(() => {
                    clearTimeout(this.option.durationClock);
                    this.close();
                }, 500);
            },
            gotoDetail () {
                this.okCallback && this.okCallback()
            }
        },
        components: {},
        mounted () {

        }
    };
</script>
<template>
    <div class="notify-area">
        <div class="nt " @click.stop="hide();" :class="[tpl, hideClass]">
            <span class="notify-img-box">
                <span class="notify-img" v-html="img.content" :style="{color: img.color}"></span>
            </span>
            <span class="notify-text">{{text}}</span>
            <span class="notify-detail" v-show="!hideDetail" :class="[hideDetail ? 'hideDetail' : '']"
                  @click.stop="gotoDetail">详情</span>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .notify-area {
        position: fixed;
        z-index: 95000;
        right: 0;
        top: 0;
        width: 100%;
        height: auto;
        min-height: 1px;
        text-align: center;
        pointer-events: none;
        transition: top ease-in 0.15s;

        > .nt {
            box-sizing: border-box;
            max-width: 75%;
            width: auto;
            overflow: hidden;
            padding: 10px 32px;
            min-height: 40px;
            height: auto;
            font-size: 14px;
            border-radius: @widgetsBorderRadius;
            color: @otherNormalTitleClr;
            font-weight: 500;
            position: relative;
            top: -40px;
            transition: top ease-in 0.15s;
            /*transform: translateY(-50%);*/
            background-color: #fff;
            cursor: pointer;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.warn {
                background-color: #feeef1;
                border: 1px solid @dangerBg;

                .notify-img-box {
                    color: @dangerActiveBg;
                }
            }

            &.success {
                background-color: #ebf6ff;
                border: 1px solid @primaryBg;

                .notify-img-box {
                    color: @primaryActiveBg;
                }
            }

            &.show {
                width: auto;
                /*transform: translateY(0);*/
                pointer-events: auto;
                top: 0;
            }


            &.hide {
                transform: scale(1, 0);
            }

            .notify-img-box {
                vertical-align: middle;
            }

            .notify-img {
                width: 30px;
                height: auto;
                vertical-align: bottom;
                font-family: cmsicon;
                font-size: 16px;
            }

            .notify-text {
                width: 150px;
                word-break: break-all;
                padding-left: 10px;
                box-sizing: border-box;
                min-height: 30px;
                height: auto;
                line-height: 1.4;
                vertical-align: middle;
            }

            .notify-detail {
                vertical-align: middle;
                width: 40px;
                height: auto;
                min-height: 30px;
                font-weight: normal;
                text-align: right;
                /*<!--border-left: 1px solid @borderColor;-->*/

                &.hideDetail {
                    border-left: none;
                    visibility: hidden;
                }
            }
        }
    }


</style>
